import React from "react";
import { useLocation } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import AppFooter from "./AppFooter";
import { MobileHomeButton, shouldShowMobileHome } from "./MealsPageChrome";

/** Routes whose page components handle their own horizontal padding (full-bleed auth hero). */
const FULL_BLEED_PATHS = [
  "/",
  "/sign-in",
  "/sign-up",
  "/onboarding",
  "/grocery/lists",
  "/grocery",
  "/focus",
  "/automation",
  "/profile",
  "/apps",
  "/habits",
  "/chores",
  "/composer",
  "/fitness",
  "/household",
  "/routines",
  "/calories",
  "/budget",
  "/music",
  "/transcribe",
  "/selling",
  "/help",
];

/**
 * Main app shell: content area with a minimal Lifestack footer.
 * Follows light/dark theme (unlike TV routes which stay navy).
 */
function AppLayout({ children }) {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fullBleed = FULL_BLEED_PATHS.includes(location.pathname);
  const showHome = isMobile && shouldShowMobileHome(location.pathname);
  const showFooter = !showHome && location.pathname !== "/grocery";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          width: "100%",
          maxWidth: fullBleed ? "100%" : { xs: "100%", lg: 1440 },
          mx: "auto",
          px: fullBleed ? 0 : { xs: 2, sm: 3 },
          py: fullBleed ? 0 : { xs: 2, sm: 3 },
          color: "inherit",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            width: "100%",
            position: "relative",
          }}
        >
          {children}
        </Box>
        {showFooter ? (
          <AppFooter sx={fullBleed ? { px: { xs: 2, sm: 3 } } : undefined} />
        ) : null}
      </Box>
      {showHome ? <MobileHomeButton /> : null}
    </Box>
  );
}

export default AppLayout;
